export function CNSYt(props) {
    const playlists = [
      {
        name: "CNSYt College",
        url: "https://www.youtube.com/watch?v=ESnrn1kAD4E&ab_channel=ApnaCollege"
      },
      {
        name: "SuperSimpleDev (Highly Recommended)",
        url: "https://www.youtube.com/watch?v=G3e-cpL7ofc&t=1062s&ab_channel=SuperSimpleDev"
      },
      {
        name: "PW Skills Tech",
        url: "https://www.youtube.com/watch?v=WuiB5TAQOAM&ab_channel=PWSkillsTech"
      },
      {
        name: "SuperSimpleDev",
        url: "https://www.youtube.com/watch?v=OXGznpKZ_sA&ab_channel=freeCodeCamp.org"
      },
      {
        name: "Bro Code",
        url: "https://www.youtube.com/watch?v=HGTJBPNC-Gw&ab_channel=BroCode"
      },
      {
        name: "FreeCodeCamp",
        url: "https://www.youtube.com/watch?v=1Rs2ND1ryYc&ab_channel=freeCodeCamp.org"
      },
      {
        name: "Thapa Technical (Recommended)",
        url: "https://www.youtube.com/watch?v=MSICFljRcb4&t=23300s&ab_channel=ThapaTechnical"
      },
      {
        name: "Anuj Bhaiya (TailWind CSS)",
        url: "https://www.youtube.com/watch?v=mGN9-FPsX9o&t=1043s&ab_channel=AnujBhaiya"
      },
      {
        name: "Apna College (Recommended)",
        url: "https://www.youtube.com/watch?v=nGhKIC_7Mkk&ab_channel=ApnaCollege"
      },
      {
        name: "Ws Cube Tech (TailWind CSS)",
        url: "https://www.youtube.com/watch?v=Sae1MD5E5p8&ab_channel=WsCubeTech"
      }
    ];
  
    return (
      <>
        <h1 className="html_yt_heading">
          These are the <strong style={{ textDecoration: 'underline', color: 'blue' }}>Top 10</strong> Youtube Playlists That You can Refer
        </h1>
  
        <h4 className="des_yt_html">
          1. Dive Into The Main Concepts <br />
          2. Animation Explanations with real world Examples <br />
          3. Important with Note Clarification.
        </h4>
  
        {playlists.map((playlist, index) => (
          <div className="container_html_yt_links" key={index}>
            <p className="vid">
              {index + 1}. {playlist.name}
              <button
                style={{
                  marginLeft: '200px',
                  padding: '7px',
                  background: 'black',
                  color: 'white',
                  borderRadius: '8px'
                }}
                onClick={() => window.open(playlist.url, "_blank")}
              >
                Click Me
              </button>
            </p>
          </div>
        ))}
      </>
    );
  }
  
  export default CNSYt;
  